document.addEventListener('DOMContentLoaded', () => {
	const drawers = document.querySelectorAll('.attorney-drawer');

	drawers.forEach(drawer => {
		const header = drawer.querySelector('.drawer-header');
		const content = drawer.querySelector('.drawer-content');

		header.addEventListener('click', () => {
			const isOpen = drawer.classList.contains('is-open');

			if (isOpen) {
				content.style.maxHeight = content.scrollHeight + 'px';
				requestAnimationFrame(() => {
					content.style.maxHeight = '0';
				});
			} else {
				content.style.maxHeight = content.scrollHeight + 'px';
			}

			drawer.classList.toggle('is-open');
			header.setAttribute('aria-expanded', !isOpen);
		});

		content.addEventListener('transitionend', () => {
			if (drawer.classList.contains('is-open')) {
				content.style.maxHeight = 'none';
			}
		});
	});
});
